<template>
    <div class="content">
        <base-header class="pb-6">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h6 class="h2 text-white d-inline-block mb-0">
                        {{ $t("shipping") }}
                    </h6>
                    <nav
                        aria-label="breadcrumb"
                        class="d-none d-md-inline-block ml-md-4"
                    >
                        <route-bread-crumb></route-bread-crumb>
                    </nav>
                </div>

               
                <div class="col-lg-6 col-5 text-right">
                    <router-link to="/backoffice/packings">
                        <base-button size="md" type="neutral" class="ml-2">{{
                            $t("back")
                        }}</base-button>
                    </router-link>
                </div>
            </div>
        </base-header>

        <div class="row">
            <div class="container-fluid mt--6 col-lg-12">
                <div>
                    <card
                        header-classes="bg-transparent"
                        footer-classes="bg-transparent"
                        body-classes="px-lg-4 py-lg-4"
                        class=" border-0  mb-2"
                    >
                        <template slot="header">
                            <div class="form-group row">
                                <div class="col-md-5">
                                    <base-input :label="$t('platform')">
                                        <el-select
                                            v-model="params.platform_id"
                                            :label="$t('platform')"
                                            :disabled="lock"
                                        >
                                            <el-option
                                                v-for="option in PlatformTable"
                                                :key="option.id"
                                                :label="option.name"
                                                :value="option.id"
                                            >
                                            </el-option>
                                        </el-select>
                                    </base-input>
                                </div>

                                <div class="col-md-5">
                                    <base-input label="ประเภทบาร์โค้ด">
                                        <el-select
                                            v-model="params.barcode_type"
                                            label="Barcode Type"
                                            :disabled="lock"
                                        >
                                            <el-option
                                                v-for="option in BarcodeTypeTable"
                                                :key="option.id"
                                                :label="option.name"
                                                :value="option.id"
                                            >
                                            </el-option>
                                        </el-select>
                                    </base-input>
                                </div>

                                <!-- Lock -->
                                <div class="col-md-2 py-4">
                                    <base-button
                                        @click="handleUnLock"
                                        v-if="lock"
                                        >UnLock</base-button
                                    >

                                    <!-- Unlock -->
                                    <base-button
                                        @click="handleLock"
                                        v-if="!lock"
                                        >Lock</base-button
                                    >
                                </div>
                            </div>
                        </template>

                        <div class="row" v-if="lock">
                            <div class="col-md-12">
                                <base-input
                                    :placeholder="$t('scanbarcode')"
                                    v-model="barcode"
                                    class="form-control-alternative"
                                    prepend-icon="ni ni-zoom-split-in"
                                    v-on:keyup.enter="handleBarcode"
                                ></base-input>
                            </div>
                            <div class="col-md-12" v-if="isWait">
                                <span>
                                    <i class="fas fa-spinner fa-spin"></i>
                                    กำลังประมวลผล...</span
                                >
                            </div>
                            <div class="col-md-12">
                                <div v-for="c in coupons" :key="c">
                                    <div>คูปอง - {{ c}} </div>
                                </div>
                            </div>
                        </div>

                    </card>
                </div>
            </div>

            </div>

            <!-- Two-column layout: Camera Settings (left) and Order Detail (right) -->
            <div class="row mt-4" v-if="lock">
                <!-- Left Column: Camera Settings -->
                <div class="container-fluid col-lg-6">
                    <card
                        header-classes="bg-transparent"
                        body-classes="px-lg-4 py-lg-4"
                        class="border-0 mb-4"
                    >
                        <template slot="header">
                            <div class="d-flex justify-content-between align-items-center flex-wrap">
                                <h4 class="mb-0">{{ $t("camera_settings") }}</h4>
                                <div class="header-controls d-flex align-items-center">
                                    <div class="connection-status mr-3">
                                        <span v-if="!hasWebcam" class="badge badge-warning">
                                            <i class="fa fa-exclamation-triangle mr-1"></i>
                                            No Webcam
                                        </span>
                                        <span v-else-if="isRecording" class="badge badge-danger">
                                            <i class="fa fa-circle mr-1 recording-pulse"></i>
                                            Recording
                                        </span>
                                        <span v-else-if="isWebcamActive" class="badge badge-success">
                                            <i class="fa fa-circle mr-1"></i>
                                            Camera Connected
                                        </span>
                                        <span v-else class="badge badge-secondary">
                                            <i class="fa fa-circle mr-1"></i>
                                            Camera Disconnected
                                        </span>
                                    </div>

                                    <!-- Recording Controls -->
                                    <div class="recording-controls" v-if="hasWebcam && isWebcamActive">
                                        <base-button
                                            v-if="!isRecording"
                                            @click="startVideoRecording"
                                            type="danger"
                                            size="sm"
                                        >
                                            <i class="fa fa-circle mr-2"></i>
                                            Start Recording
                                        </base-button>
                                        <base-button
                                            v-if="isRecording"
                                            @click="stopVideoRecording"
                                            type="warning"
                                            size="sm"
                                        >
                                            <i class="fa fa-stop mr-2"></i>
                                            Stop & Save ({{ recordingDuration }})
                                        </base-button>
                                    </div>
                                </div>
                            </div>
                        </template>

                        <div class="webcam-container">
                            <!-- Webcam Display -->
                            <div class="webcam-display-area mb-3">
                                <div v-if="hasWebcam" class="video-container">
                                    <video
                                        ref="webcamVideo"
                                        width="100%"
                                        height="auto"
                                        autoplay
                                        muted
                                        playsinline
                                        v-show="isWebcamActive"
                                        :class="{'webcam-video': true, 'recording': isRecording}"
                                    ></video>

                                    <!-- Recording indicator overlay -->
                                    <div v-if="isRecording" class="recording-indicator">
                                        <i class="fa fa-circle recording-pulse"></i>
                                        <span>REC {{ recordingDuration }}</span>
                                    </div>
                                </div>

                                <div v-if="!hasWebcam" class="webcam-placeholder">
                                    <i class="fa fa-exclamation-triangle fa-3x text-warning"></i>
                                    <p class="text-warning mt-2"><strong>No Webcam Detected</strong></p>
                                    <p class="text-muted">Please connect a webcam and refresh the page</p>
                                </div>

                                <div v-else-if="!isWebcamActive" class="webcam-placeholder">
                                    <i class="fa fa-video-camera fa-3x text-muted"></i>
                                    <p class="text-muted mt-2">Click "Connect" to start camera preview</p>
                                </div>
                            </div>

                            <!-- Camera Selection and Quality Settings -->
                            <div class="camera-selection-section mb-4" :class="{'disabled-section': !hasWebcam}">
                                <div class="row">
                                    <div class="col-md-12">
                                        <base-input>
                                            <el-select
                                                v-model="selectedCameraId"
                                                @change="onCameraChange"
                                                placeholder="Choose camera device"
                                                :disabled="!hasWebcam"
                                                class="w-100"
                                            >
                                                <el-option
                                                    v-for="camera in availableCameras"
                                                    :key="camera.deviceId"
                                                    :label="camera.label || `Camera ${camera.deviceId.substring(0, 8)}...`"
                                                    :value="camera.deviceId"
                                                >
                                                </el-option>
                                            </el-select>
                                        </base-input>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <base-input>
                                            <el-select
                                                v-model="selectedVideoQuality"
                                                @change="onVideoQualityChange"
                                                placeholder="Select quality"
                                                :disabled="!hasWebcam"
                                                class="w-100"
                                            >
                                                <el-option
                                                    label="2K - Default"
                                                    value="2k"
                                                >
                                                </el-option>
                                                <el-option
                                                    label="4K"
                                                    value="4k"
                                                >
                                                </el-option>
                                            </el-select>
                                        </base-input>
                                    </div>
                                    <div class="col-md-6">
                                        <base-button
                                            @click="connectCamera"
                                            :type="isWebcamActive ? 'success' : 'info'"
                                            size="md"
                                            class="w-100 text-nowrap"
                                            :disabled="!hasWebcam"
                                        >
                                            <i :class="isWebcamActive ? 'fa fa-check-circle' : 'fa fa-plug'" class="mr-1"></i>{{ isWebcamActive ? 'Connected' : 'Connect' }}
                                        </base-button>
                                    </div>
                                </div>

                                <!-- Quality Info -->
                                <div class="row mt-3" v-if="hasWebcam && selectedVideoQuality">
                                    <div class="col-md-12">
                                        <div class="alert" :class="isRecording ? 'alert-danger' : 'alert-info'">
                                            <small>
                                                <i :class="isRecording ? 'fa fa-circle recording-pulse mr-2' : 'fa fa-info-circle mr-2'"></i>
                                                <span v-if="isRecording">
                                                    <strong>RECORDING</strong> - {{ getQualityDisplayText() }} - {{ recordingDuration }}
                                                </span>
                                                <span v-else>
                                                    Current Quality: {{ getQualityDisplayText() }}
                                                </span>
                                            </small>
                                        </div>
                                    </div>
                                </div>

                                <!-- No Webcam Message -->
                                <div class="row mt-3" v-if="!hasWebcam">
                                    <div class="col-md-12">
                                        <div class="alert alert-warning">
                                            <small>
                                                <i class="fa fa-exclamation-triangle mr-2"></i>
                                                Camera features are disabled. No webcam detected.
                                            </small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </card>
                </div>

                <!-- Right Column: Order Detail -->
                <div class="container-fluid col-lg-6" v-if="state == 1">
                    <card
                        class="no-border-card"
                        body-classes="px-0 pb-1"
                        footer-classes="pb-2"
                    >
                        <template slot="header">
                            <div class="row">
                                <label
                                    class="col-md-12 col-form-label form-control-label"
                                >
                                    <h3 class="mb-0">
                                        {{ $t("order_information") }} :
                                        {{ this.order.ID }}
                                    </h3>
                                    <p class="mb-0 mt-2">
                                        <strong>Tracking:</strong> {{ this.order.shipping_tracking_number }} ({{ this.order.shipping_provider_name }})
                                    </p>
                                    <p class="mb-0 mt-2">
                                        <strong>สถานะ:</strong>
                                        <template v-if="order.order_status == 100"> <span class="btn btn-sm"> {{ $t("order_status_unpaid")}} </span> </template>
                                        <template v-if="order.order_status == 111"> <span class="btn btn-info btn-sm"> {{ $t("order_status_awaiting_shipment") }} </span></template>
                                        <template v-if="order.order_status == 112"> <span class="btn btn-info btn-sm"> {{ $t("order_status_awaitingcollection") }} </span></template>
                                        <template v-if="order.order_status == 114"> <span class="btn btn-info btn-sm"> {{ $t("order_status_partiallyshipping") }} </span></template>
                                        <template v-if="order.order_status == 115"> <span class="btn btn-info btn-sm"> {{ $t("order_status_awaiting_transit") }} </span></template>
                                        <template v-if="order.order_status == 121"> <span class="btn btn-primary btn-sm"> {{ $t("order_status_intransit") }} </span></template>
                                        <template v-if="order.order_status == 122"> <span class="btn btn-primary btn-sm"> {{ $t("order_status_delivered") }} </span></template>
                                        <template v-if="order.order_status == 130"> <span class="btn btn-success btn-sm"> {{ $t("order_status_completed") }} </span></template>
                                        <template v-if="order.order_status == 140"> <span class="btn btn-danger btn-sm"> {{ $t("order_status_cancelled") }} </span></template>
                                        <template v-if="order.order_status == 141"> <span class="btn btn-danger btn-sm"> {{ $t("order_status_returned") }} </span></template>
                                        <template v-if="order.order_status == 142"> <span class="btn btn-danger btn-sm"> {{ $t("order_status_claimed") }} </span></template>
                                        <template v-if="order.order_status == 143"> <span class="btn btn-warning btn-sm"> {{ $t("order_status_returning") }} </span></template>
                                    </p>
                                </label>
                            </div>

                            <div class="row mt-2">
                                <div class="col">
                                    <strong>คูปอง:</strong>
                                    <span class="btn btn-primary btn-sm ml-1" v-for="c in order_coupons" :key="c.running_number"> {{ c.running_number}} </span>
                                </div>
                            </div>
                        </template>
                        <!-- Selected Product -->
                        <div class="row">
                            <div
                                class="col-lg-6 col-md-6"
                                v-for="p in wms_product"
                                :key="p.id"
                            >
                                <div class="card">
                                    <img
                                        class="card-img-top"
                                        :src="GetProductImage(p.wms_product_id)"
                                        style="max-height:120px; width:120px;margin-left: auto; margin-right: auto;"
                                    />
                                    <div class="card-body">
                                        <h4>
                                            <span>
                                                {{ p.wms_product_name }}
                                            </span>
                                            (
                                            <span
                                                >{{
                                                    p.pickup_quantity
                                                }}

                                            </span>
                                            )
                                        </h4>


                                        <div class="col-md-12">
                                            {{ p.barcode }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </card>
                </div>
            </div>

        <!--  Modal -->
        <modal :show.sync="showModal" modal-classes="modal-secondary">
            <form class="new-event--form" @submit.prevent="saveEvent">
                Loading...
            </form>

            <template slot="footer"> </template>
        </modal>

		<modal :show.sync="showSyncModal" modal-classes="modal-secondary">
			<validation-observer ref="formValidator" >

            <form class="new-event--form" @submit.prevent="saveEvent">
                <base-input :label="$t('platform_order_id')" :name="$t('platform_order_id')" v-model="platform_order_id" rules="required"> </base-input>
            </form>
			</validation-observer>

            <template slot="footer">
                <button
                    type="submit"
                    class="btn btn-md btn-primary"
                    @click="handlePlatformSync()"
                >
                    Sync
                </button>
                <button
                    type="button"
                    class="btn btn-md btn-link ml-auto"
                    @click="showSyncModal = false"
                >
                    {{ $t("close") }}
                </button>
            </template>
        </modal>
    </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "../PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";
import FileInput from "@/components/Inputs/FileInput";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { CouponService } from "../../resource";
import moment from "moment";

export default {
    mixins: [clientPaginationMixin],
    components: {
        flatPicker,
        FileInput,
        BasePagination,
        RouteBreadCrumb,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn
    },
    computed: {
        ...mapGetters({
            StorageTableOrg: "WmsStorage/getData",
            // #416 ruling: packing / return rooms verify order contents (barcode + image); old
            // orders with a disabled product must still pack, so this reads the active=all list.
            ProductTable: "WmsProduct/getDataAll",
            PlatformTable: "Order/getPlatformTable",
            OrderStatusTable: "Order/OrderStatusTableWithAll",
        }),

        BarcodeTypeTable() {
            return [
                { id: 1, name: "Order" },
                { id: 2, name: "Tracking" },
            ];
        },

        StorageTable() {
            return this.StorageTableOrg.filter(item => {
                return item.ID != 1;
            });
        }
    },
    watch: {
        "params.platform_id": {
            handler: function(val) {
                switch (val) {
                    case 1: // self
                        this.params.barcode_type = 1;
                        break;
                    case 2: // Tiktoke
                        this.params.barcode_type = 2;
                    case 3: // shopee
                        this.params.barcode_type = 2;
                    case 4: // lazada
                        this.params.barcode_type = 2;
                    case 5: // line
                        this.params.barcode_type = 2;
                        break;
                }
                console.log("platform_id", val);
            },
            deep: true
        },
    },
    data() {
        return {
            isLoading: false,
            showModal: false,
            lock: false,
            isWait: false,
            order: {},
            wms_product: [],

            state: 0,
            barcode: "",
            first_barcode: "",
            pickup_items: [], // สินค้าที่หยิบใส่กล่องแล้ว
            order_items: [], // สินค้าที่เลือกจาก Order
            coupons: [],
            order_coupons: [],

            params: {
                id: 7,
                shipping_provider_id: 0,
                tracking_number: "",
                storage_id: "",
                barcode: "",
                platform_id: 1,
                barcode_type: 1
            },

			showSyncModal: false,
			platform_order_id:"",

            propsToSearch: [],

            // Webcam variables
            isWebcamActive: false,
            webcamStream: null,
            availableCameras: [],
            selectedCameraId: '',
            selectedVideoQuality: '2k',
            hasWebcam: true,
            webcamConfigs: {
                '2k': {
                    width: 2560,
                    height: 1440,
                    frameRate: 30
                },
                '4k': {
                    width: 3840,
                    height: 2160,
                    frameRate: 30
                }
            },
            // Video recording variables
            isRecording: false,
            mediaRecorder: null,
            recordedChunks: [],
            recordingStartTime: null,
            recordingDuration: '00:00',
            recordingTimer: null,
            // Current order info for recording
            currentOrderId: '',
            currentBarcode: '',
            // Saved order info for video file naming (captured before stop)
            savedOrderIdForVideo: '',
            savedBarcodeForVideo: ''
        };
    },
    async mounted() {
        this.listStorage();
        this.listProduct({ active: "all" });
        this.clearParam();
        this.checkWebcamAvailability();

		try {
            let resp = await this.getProfile()
            let user = resp.data.Datum
            console.log(user)
            this.params.storage_id = user.wms_storage_id

            if (this.params.storage_id == 0) {
                swal.fire({
                    title: "ผู้ใช้งานนี้ยังไม่ได้ตั้งค่าคลังสินค้า",
                    text: "กรุณาติดต่อผู้ดูแลระบบเพื่อตั้งค่าคลังสินค้า",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false,
                }).then(()=>{
                    this.$router.go(-1)
                })

            }
        } catch (err){
            console.log(err)
            swal.fire({
                title: "ตรวจสอบข้อมูลคลังสินค้าผิดพลาด",
                text: "กรุณาติดต่อผู้ดูแลระบบเพื่อตั้งค่าคลังสินค้า",
                icon: "error",
                confirmButtonClass: "btn btn-danger btn-fill",
                buttonsStyling: false,
            }).then(()=>{
                this.$router.go(-1)
            })
        }
    },
    beforeDestroy() {
        this.stopWebcam();
    },
    methods: {
        ...mapActions({
            listSaleChannel: "SaleChannel/listData",
            listStorage: "WmsStorage/listData",
            listProduct: "WmsProduct/listData",
            addItem: "Packing/addPickupItem",
            removeItem: "Packing/removePickupItem",
            closeOrder: "Packing/closeShippingOrder",
			syncPlatformOrder : "Order/syncPlatformOrder",
			getProfile : "Auth/getProfile",
			shippingCreateAndCloseWithCoupon: "Packing/shippingCreateAndCloseWithCoupon",
			shippingLinkCoupon: "Packing/shippingLinkCoupon"
        }),
        async handleBarcode() {
            console.log("handleBarcode", this.barcode);
            console.log("state", this.state);

            this.params.barcode = this.barcode;
            this.barcode = "";


            if (this.isWait) {
                console.log("isLoading... , cancel this barcode");
                return;
            }

            if (this.params.barcode != "CLOSEORDERMDF" && !this.params.barcode.startsWith("http")) {
                // force state to 0
                this.state = 0;
            }

            switch(this.state){
                case 0:
                // ================================  Wait  order id or tracking  ================================
                    this.first_barcode = this.params.barcode;

                    console.log("state:0 , platform_id", this.params.platform_id);
                    if (this.params.barcode_type == 1) {
                        // MDF must be order
                        let isOrder = this.params.barcode.startsWith("MDF");
                        let orderId = this.params.barcode.replace("MDF", "");

                        try {
                            orderId = parseInt(orderId);
                        } catch (error) {
                            console.log("error", error);
                            this.showModal = false;
                            swal.fire({
                                title: error,
                                text: "",
                                icon: "error",
                                confirmButtonClass: "btn btn-danger btn-fill",
                                buttonsStyling: false
                            });
                            return;
                        }
                        console.log("isOrder", isOrder);
                        if (!isOrder) {
                            this.showModal = false;
                            swal.fire({
                                title: "Barcode ไม่ถูกต้อง",
                                text: "Barcode ต้องเป็นรหัส Order เท่านั้น",
                                icon: "error",
                                confirmButtonClass: "btn btn-danger btn-fill",
                                buttonsStyling: false
                            });
                            return;
                        }

                        this.params.id = orderId;
                    } else {

                    }
                    console.log("params", this.params);
                    this.processOrder();
                    break;

                    case 1:
                    //================================ Get Coupon Or Close Order ================================

                    if (this.params.barcode == "CLOSEORDERMDF")
					{
                        // check coupon is exist
                        if (this.coupons.length == 0) {
                            swal.fire({
                                title: "กรุณาเพิ่มคูปอง",
                                text: "",
                                icon: "error",
                                confirmButtonClass: "btn btn-danger btn-fill",
                                buttonsStyling: false
                            });
                            return;
                        }

                        // alert("Preocess Order")
                        this.processCoupon();
                        // Linke Copupon
                        return;

					}


                    // params.barcode is url
                    if (this.params.barcode.startsWith("http")) {
                        // check coupon is exist

                        // example of url is https://event.madamefin.com/register?number=900099&code=mrqKsiEp4M   , i need to extrack queryparams (number)
                        let url = new URL(this.params.barcode);
                        let coupon_number = url.searchParams.get("number");
                        let coupon_code = url.searchParams.get("code");

                        // Remove non-numeric characters from coupon_number (e.g. prefix)
                        if (coupon_number) {
                            coupon_number = coupon_number.replace(/\D/g, '');
                        }

                        console.log("coupon_number", coupon_number);
                        console.log("coupon_code", coupon_code);

                        if (coupon_number == "" || coupon_code =="") {
                            swal.fire({
                                title: "คูปองไม่ถูกต้อง",
                                text: "Nmber=" + coupon_number + " Code=" + coupon_code,
                                icon: "error",
                                confirmButtonClass: "btn btn-danger btn-fill",
                                buttonsStyling: false
                            });
                            return;
                        }

                        // check coupon is exist
                        let coupon = this.coupons.find(x => x == coupon_number);
                        if (coupon) {
                            swal.fire({
                                title: "คูปองนี้ถูกเพิ่มแล้ว",
                                text: "Nmber=" + coupon_number + " Code=" + coupon_code,
                                icon: "error",
                                confirmButtonClass: "btn btn-danger btn-fill",
                                buttonsStyling: false
                            });
                            return;
                        }

                        // add coupon number to coupons  with ["00","11","22"]
                        try {
                            coupon_number = parseInt(coupon_number);
                            this.coupons.push(coupon_number);
                        } catch (error) {
                            console.log("error", error);
                            this.showModal = false;
                            swal.fire({
                                title: error,
                                text: "เพิ่มคูปองไม่สำเร็จ",
                                icon: "error",
                                confirmButtonClass: "btn btn-danger btn-fill",
                                buttonsStyling: false
                            });
                            return;
                        }
                        return

                    }


                    swal.fire({
                        title: "คูปองไม่ถูกต้อง",
                        text: "Barcode  ต้องเป็นคูปองหรือปิด Order เท่านั้น",
                        icon: "error",
                        confirmButtonClass: "btn btn-danger btn-fill",
                        buttonsStyling: false
                    });

                    break;

            }
            // Fetch Order ID





        },

        async processOrder() {
            this.isWait = true;
            this.showModal = true;
            try {
                let params = {
                    id: this.params.barcode_type == 1 ? this.params.id : 0,
                    storage_id: this.params.storage_id,
                    coupon_numbers : this.coupons,
                    barcode: this.params.barcode_type == 2 ?this.first_barcode: "",
                    platform_id : this.params.platform_id
                }

                console.log ("params", params)
                // this.isWait = false;
				// this.showModal = false;
				let resp = await this.shippingCreateAndCloseWithCoupon(params)

				// Success
				this.showModal = false;
                this.isWait = false;
				this.clearParam();
                this.order = resp.data.Datum.order;

                this.order_coupons = resp.data.Datum.coupons;
                this.wms_product = JSON.parse(this.order.wms_product_summary);
                this.state = 1;

                // Store current order info for video recording
                this.currentOrderId = this.order.ID;
                this.savedOrderIdForVideo = this.order.ID;
                this.savedBarcodeForVideo = this.order.shipping_tracking_number;

                // Auto-connect camera when order is opened (only if webcam is available)
                if (this.hasWebcam && !this.isWebcamActive) {
                    await this.connectCamera();
                }

                // Auto-start recording when order is successfully loaded
                if (this.hasWebcam) {
                    setTimeout(async () => {
                        if (this.isWebcamActive && !this.isRecording) {
                            this.startVideoRecording();
                        }
                    }, 1000);
                }

				// swal.fire({
				// 	title: "สร้างรายการส่งสินค้าเรียบร้อย",
				// 	text: "",
				// 	icon: "success",
				// 	confirmButtonClass: "btn btn-success btn-fill",
				// 	buttonsStyling: false
				// });
			}
			catch (err) {
				console.log(err)
                this.isWait = false;
				this.showModal = false;
				swal.fire({
					title: this.$t(err.response.data.Msg),
					text: err.response.data.Cause,
					icon: "error",
					confirmButtonClass: "btn btn-danger btn-fill",
					buttonsStyling: false
				});
				return;
			}
        },

        async processCoupon() {
            this.isWait = true;
            this.showModal = true;
            try {
                let params = {
                    id: this.order.ID,
                    tracking_number: this.order.shipping_tracking_number,
                    coupon_numbers : this.coupons
                }

                let resp = await this.shippingLinkCoupon(params)

                swal.fire({
					title: "เพิ่มคูปองสำเร็จ",
					text: "",
					icon: "success",
					confirmButtonClass: "btn btn-success btn-fill",
					buttonsStyling: false
				}).then(()=>{
                    this.showModal = false;
                    this.isWait = false;
                    this.clearParam();
                });
            }
            catch (err) {
                console.log(err)
                this.isWait = false;
                this.showModal = false;
                swal.fire({
                    title: this.$t(err.response.data.Msg),
                    text: err.response.data.Cause,
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
                return;
            }

        },

        handleLock() {
            //  check storage sleected
            if (this.params.storage_id == "") {
                swal.fire({
                    title: "Error",
                    text: "กรุณาเลือกคลังสินค้า",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
                return;
            }

            this.lock = true;
            this.clearParam();
        },
        handleUnLock() {
            this.lock = false;
            this.clearParam();
        },
        clearParam() {
            // Stop recording when clearing order
            if (this.isRecording) {
                this.stopVideoRecording();
            }

            this.order_items = [];
            this.pickup_items = [];
            this.params.id = "";
            this.params.tracking_number = "";
            this.params.barcode = "";
            this.barcode = "";
            this.coupons = [];
            this.first_barcode = "";
            this.state = 0;

            // Clear current order info for recording
            this.currentOrderId = '';
            this.currentBarcode = '';
        },
        GetProductImage(id) {
            // find product table
            let product = this.ProductTable.find(x => x.ID == id);
            if (product) {
                return (
                    process.env.VUE_APP_API_BASE_URL +
                    "/files/wms_products/" +
                    product.Image
                );
            } else {
                return "";
            }
        },
        GetOrderStatus(id) {
            var data = this.OrderStatusTable;
            var result = data.find(x => x.ID === id);
            return result != null ? result.Name : "-";
        },

        // Webcam methods
        async startWebcam() {
            try {
                if (this.webcamStream) {
                    this.webcamStream.getTracks().forEach(track => track.stop());
                }

                const currentConfig = this.webcamConfigs[this.selectedVideoQuality];
                const constraints = {
                    video: {
                        width: { ideal: currentConfig.width, min: 640 },
                        height: { ideal: currentConfig.height, min: 480 },
                        frameRate: { ideal: currentConfig.frameRate, min: 15 }
                    }
                };

                if (this.selectedCameraId) {
                    constraints.video.deviceId = { exact: this.selectedCameraId };
                }

                console.log('Requesting webcam with constraints:', constraints);

                try {
                    this.webcamStream = await navigator.mediaDevices.getUserMedia(constraints);
                } catch (error) {
                    console.warn('High quality constraints failed, trying with fallback constraints:', error);
                    const fallbackConstraints = {
                        video: {
                            width: { ideal: 1280, min: 640 },
                            height: { ideal: 720, min: 480 },
                            frameRate: { ideal: 30, min: 15 }
                        }
                    };
                    if (this.selectedCameraId) {
                        fallbackConstraints.video.deviceId = { exact: this.selectedCameraId };
                    }
                    this.webcamStream = await navigator.mediaDevices.getUserMedia(fallbackConstraints);
                }

                const videoTrack = this.webcamStream.getVideoTracks()[0];
                const settings = videoTrack.getSettings();

                console.log('Video track settings:', settings);
                videoTrack.enabled = true;

                const videoElement = this.$refs.webcamVideo;
                videoElement.srcObject = this.webcamStream;

                await new Promise((resolve) => {
                    videoElement.addEventListener('loadedmetadata', resolve, { once: true });
                });

                this.isWebcamActive = true;
                console.log(`✓ Webcam active (${settings.width}x${settings.height}@${settings.frameRate}fps)`);

            } catch (error) {
                console.error('Error accessing webcam:', error);

                try {
                    const fallbackConstraints = { video: true };
                    console.log('Trying fallback constraints:', fallbackConstraints);
                    this.webcamStream = await navigator.mediaDevices.getUserMedia(fallbackConstraints);

                    const videoTrack = this.webcamStream.getVideoTracks()[0];
                    console.log('Fallback video track settings:', videoTrack.getSettings());

                    this.$refs.webcamVideo.srcObject = this.webcamStream;
                    this.isWebcamActive = true;
                } catch (fallbackError) {
                    console.error('Fallback webcam access failed:', fallbackError);
                    swal.fire({
                        title: 'Error',
                        text: 'Could not access webcam. Please check permissions and camera selection.',
                        icon: 'error',
                        confirmButtonText: this.$t("ok")
                    });
                }
            }
        },

        stopWebcam() {
            if (this.isRecording) {
                this.stopVideoRecording();
            }

            if (this.webcamStream) {
                this.webcamStream.getTracks().forEach(track => track.stop());
                this.webcamStream = null;
            }
            this.isWebcamActive = false;
        },

        async connectCamera() {
            if (this.isWebcamActive) {
                this.stopWebcam();
            } else {
                await this.getCameraDevices();
                await this.startWebcam();
            }
        },

        async onVideoQualityChange() {
            await this.connectCamera();

            swal.fire({
                title: 'Quality Changed',
                text: `Camera connected with ${this.selectedVideoQuality.toUpperCase()} quality (${this.getQualityDisplayText()})`,
                icon: 'success',
                timer: 2000,
                showConfirmButton: false
            });
        },

        getQualityDisplayText() {
            const config = this.webcamConfigs[this.selectedVideoQuality];
            return `${config.width}x${config.height} @ ${config.frameRate}fps`;
        },

        startVideoRecording() {
            if (!this.webcamStream) {
                console.error('No webcam stream available');
                return;
            }

            this.recordedChunks = [];
            this.recordingStartTime = moment();

            let options = null;
            const supportedTypes = [
                'video/webm;codecs=vp9',
                'video/webm;codecs=vp8',
                'video/webm',
                'video/mp4'
            ];

            for (const type of supportedTypes) {
                if (MediaRecorder.isTypeSupported(type)) {
                    console.log('Using supported type:', type);
                    options = { mimeType: type };

                    if (type.includes('webm')) {
                        if (this.selectedVideoQuality === '4k') {
                            options.videoBitsPerSecond = 25000000;
                        } else {
                            options.videoBitsPerSecond = 10000000;
                        }
                    }
                    break;
                }
            }

            try {
                this.mediaRecorder = new MediaRecorder(this.webcamStream, options);
                console.log('MediaRecorder created with options:', options);

                this.mediaRecorder.ondataavailable = (event) => {
                    if (event.data.size > 0) {
                        this.recordedChunks.push(event.data);
                    }
                };

                this.mediaRecorder.onstop = () => {
                    this.saveVideoFile();
                };

                this.mediaRecorder.onerror = (event) => {
                    console.error('MediaRecorder error:', event.error);
                    swal.fire({
                        title: 'Recording Error',
                        text: 'Error during recording: ' + event.error,
                        icon: 'error',
                        confirmButtonText: 'OK'
                    });
                };

                this.mediaRecorder.start(100);
                this.isRecording = true;
                this.startDurationTimer();

                console.log('Video recording started at', this.selectedVideoQuality.toUpperCase(), 'quality');

            } catch (error) {
                console.error('Failed to create MediaRecorder:', error);
                swal.fire({
                    title: 'Recording Error',
                    text: 'Cannot create video recorder. Please try a different browser.',
                    icon: 'error',
                    confirmButtonText: 'OK'
                });
            }
        },

        stopVideoRecording() {
            if (this.mediaRecorder && this.isRecording) {
                // Capture order info before stopping (before clearParam clears them)
                // this.savedOrderIdForVideo = this.currentOrderId;
                // this.savedBarcodeForVideo = this.currentBarcode;

                this.mediaRecorder.stop();
                this.isRecording = false;

                if (this.recordingTimer) {
                    clearInterval(this.recordingTimer);
                    this.recordingTimer = null;
                }
            }
        },

        startDurationTimer() {
            this.recordingTimer = setInterval(() => {
                if (this.recordingStartTime && this.isRecording) {
                    const now = moment();
                    const duration = moment.duration(now.diff(this.recordingStartTime));
                    this.recordingDuration = moment.utc(duration.asMilliseconds()).format('mm:ss');
                }
            }, 1000);
        },

        saveVideoFile() {
            if (this.recordedChunks.length === 0) {
                console.error('No recording chunks available');
                swal.fire({
                    title: 'Recording Error',
                    text: 'No video data was recorded. Please try again.',
                    icon: 'error',
                    confirmButtonText: 'OK'
                });
                return;
            }

            let mimeType = 'video/webm';
            if (this.mediaRecorder.mimeType) {
                mimeType = this.mediaRecorder.mimeType;
            }

            const blob = new Blob(this.recordedChunks, { type: mimeType });

            // Use saved values (captured before stop) as they may be cleared by clearParam
            const orderId = this.savedOrderIdForVideo || 'unknown';
            const barcode = this.savedBarcodeForVideo || 'unknown';

            let extension = 'webm';
            if (mimeType.includes('mp4')) {
                extension = 'mp4';
            }

            const filename = `SHIPPING_${orderId}_${barcode}.${extension}`;
            const recordingEndTime = moment();
            const duration = moment.duration(recordingEndTime.diff(this.recordingStartTime));
            const durationString = moment.utc(duration.asMilliseconds()).format('mm:ss');

            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            URL.revokeObjectURL(url);
            document.body.removeChild(a);

            console.log(`Video saved: ${filename} (${durationString})`);

            // Clear saved values after video is saved
            this.savedOrderIdForVideo = '';
            this.savedBarcodeForVideo = '';
        },

        async checkWebcamAvailability() {
            try {
                if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
                    this.hasWebcam = false;
                    this.showWebcamNotFoundAlert();
                    return;
                }

                await this.getCameraDevices();

                if (this.availableCameras.length === 0) {
                    this.hasWebcam = false;
                    this.showWebcamNotFoundAlert();
                } else {
                    this.hasWebcam = true;
                }
            } catch (error) {
                console.error('Error checking webcam availability:', error);
                this.hasWebcam = false;
                this.showWebcamNotFoundAlert();
            }
        },

        showWebcamNotFoundAlert() {
            swal.fire({
                title: this.$t("webcam_not_found"),
                text: 'No webcam detected. Please connect a webcam and refresh the page.',
                icon: "warning",
                confirmButtonText: this.$t("ok")
            });
        },

        async getCameraDevices() {
            try {
                const devices = await navigator.mediaDevices.enumerateDevices();
                this.availableCameras = devices.filter(device => device.kind === 'videoinput');

                if (this.availableCameras.length > 0 && !this.selectedCameraId) {
                    this.selectedCameraId = this.availableCameras[0].deviceId;
                }
            } catch (error) {
                console.error('Error getting camera devices:', error);
                this.availableCameras = [];
            }
        },

        async onCameraChange() {
            if (this.isWebcamActive) {
                this.stopWebcam();
                setTimeout(() => {
                    this.startWebcam();
                }, 500);
            }
        }
    }
};
</script>

<style scoped>
.el-table td {
    padding: 0 !important;
}

.webcam-container {
    text-align: center;
}

.webcam-display-area {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 260px;
    background-color: #f8f9fa;
    border: 2px dashed #dee2e6;
    border-radius: 8px;
}

.video-container {
    position: relative;
    display: block;
    width: 100%;
}

.webcam-video {
    border: 2px solid #28a745;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
    width: 100%;
    max-width: 100%;
    height: auto;
}

.webcam-video.recording {
    border: 2px solid #dc3545;
    box-shadow: 0 4px 8px rgba(220, 53, 69, 0.3);
}

.recording-indicator {
    position: absolute;
    top: 10px;
    left: 10px;
    background: rgba(220, 53, 69, 0.9);
    color: white;
    padding: 5px 10px;
    border-radius: 4px;
    font-size: 14px;
    font-weight: bold;
    display: flex;
    align-items: center;
    gap: 5px;
}

.webcam-placeholder {
    text-align: center;
    color: #6c757d;
}

.recording-controls {
    display: flex;
    justify-content: center;
    gap: 10px;
    flex-wrap: wrap;
}

.header-controls {
    gap: 15px;
}

.camera-selection-section {
    background-color: #f8f9fa;
    padding: 20px;
    border-radius: 8px;
    border: 1px solid #dee2e6;
}

.disabled-section {
    opacity: 0.6;
    pointer-events: none;
}

.connection-status .badge {
    font-size: 0.9rem;
    padding: 0.5rem 1rem;
}

.connection-status .badge .fa-circle {
    animation: pulse 2s infinite;
}

@keyframes pulse {
    0% { opacity: 1; }
    50% { opacity: 0.5; }
    100% { opacity: 1; }
}

.recording-pulse {
    animation: recording-blink 1s infinite;
    color: #dc3545 !important;
}

@keyframes recording-blink {
    0% { opacity: 1; }
    50% { opacity: 0.3; }
    100% { opacity: 1; }
}

@media (max-width: 768px) {
    .header-controls {
        flex-direction: column;
        align-items: stretch;
        gap: 10px;
        margin-top: 10px;
    }

    .connection-status {
        margin-right: 0 !important;
        margin-bottom: 10px;
    }

    .recording-controls {
        width: 100%;
    }

    .recording-controls .btn {
        width: 100%;
    }
}
</style>
